export const stockPositionReport = {
	label: "Posición de Inventario",
	title: "Informe de Posición de Inventario",
	filters: {
		period: "Período",
		storage: "Inventario",
		apply: "Aplicar filtros",
		clean: "Limpiar filtros",
	},
	paragraph:
		"El informe de Posición de Inventario permite una visión de cómo estaba el inventario en determinado período mostrando los productos de los inventarios seleccionados, sus cantidades y costos.",
	selectStock: "Seleccione el inventario",
	emptyMessage: {
		title: "Seleccione inventario para comenzar",
		description:
			"Seleccione el inventario y el día deseado para visualizar el informe de posición del inventario",
	},
	table: {
		product: "Producto",
		initialQuantity: "Cantidad inicial",
		finalQuantity: "Cantidad final",
		maxQuantity: "Cantidad máxima",
		minQuantity: "Cantidad mínima",
		replacement: "Reposición sugerida",
		averageCost: "Costo promedio",
		totalCost: "Costo total",
		total: "Total",
	},
};
